import axios from 'axios'
import { MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'

const http = axios.create({
  baseURL: '/api/v1',
  timeout: 15000
})

http.interceptors.request.use(config => {
  const token = store.getters['auth/token']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  response => {
    const data = response.data
    if (data.code !== 0) {
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      if (status === 401) {
        // Login endpoint 401 means wrong credentials, not session expired
        const isLoginRequest = error.config.url && error.config.url.includes('/auth/login')
        if (!isLoginRequest) {
          store.commit('auth/CLEAR_TOKEN')
          router.push('/login').catch(() => {})
          MessageBox.alert('登录已过期，请重新登录', '提示', { type: 'warning' })
        }
      } else if (status === 429) {
        const retryAfter = data.data?.retry_after || 30
        return Promise.reject(new Error(`请求过于频繁，请 ${retryAfter} 秒后重试`))
      }
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return Promise.reject(error)
  }
)

export default http
